import { useMutation, useQueryClient } from "@tanstack/react-query";
import { merchantKeys } from "Api/Queries/Merchants/useGetMerchantQuery";
import {
  type MerchantStatus,
  putMerchantsPublicIDStatus,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Variables = {
  merchantPublicID: string;
  status: MerchantStatus;
};

type Props = {
  onSuccess?: () => void;
  onError?: () => void;
};

export const useUpdateMerchantStatusMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      ({ merchantPublicID, status }: Variables) =>
        putMerchantsPublicIDStatus(status, merchantPublicID),
    ),
    onSuccess: (_, { merchantPublicID }: Variables) => {
      queryClient.invalidateQueries({
        queryKey: merchantKeys.byMerchantPublicId(merchantPublicID),
      });
      onSuccess?.();
    },
    onError,
  });
};
